import { render } from "./SchoolActivationView.vue?vue&type=template&id=041bbdfb&ts=true"
import script from "./SchoolActivationView.vue?vue&type=script&lang=ts"
export * from "./SchoolActivationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__